export class NativeStreamProfileSampleConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "rowsPerHour",
            "baseName": "rowsPerHour",
            "type": "number",
            "format": ""
        },
        {
            "name": "retentionHours",
            "baseName": "retentionHours",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamProfileSampleConfig.attributeTypeMap;
    }
    constructor() {
    }
}
